import { Pipe, PipeTransform } from '@angular/core';
import { ICheckboxFilterableTableColumn, IFilterableTableColumn } from '../components/filterable-table/filterable-table.component';

@Pipe({
  name: 'isCheckboxColumn'
})
export class IsCheckboxColumnPipe implements PipeTransform {

  transform<T>(column: IFilterableTableColumn<T>): column is ICheckboxFilterableTableColumn<T> {
    return this.isCheckboxColumn(column);
  }

  private isCheckboxColumn<T>(column: IFilterableTableColumn<T>): column is ICheckboxFilterableTableColumn<T> {
    return column.valueType === 'checkbox';
  }
}